import { Suppliermanager } from '@linktivity/link-connect';
import configParams from '../config';

const config = new Suppliermanager.Configuration(configParams);
const supplierApi = new Suppliermanager.SupplierApi(config);

export default supplierApi;
